import { render, staticRenderFns } from "./SalonAccesses.vue?vue&type=template&id=76a4b574&scoped=true"
import script from "./SalonAccesses.vue?vue&type=script&lang=ts"
export * from "./SalonAccesses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a4b574",
  null
  
)

export default component.exports